import { fetchCalendarRecommendations } from 'actions/RecommendationActions'
import { getCalendarRecommendationsRequestKey, monthIndexToMonth } from 'api/recommendations'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import moment from 'moment'
import { useEffect, useMemo } from 'react'

function useCalendarRecommendations(
  offerId: string,
  checkIn: string | undefined,
  monthIndex: string | undefined,
  duration: number,
  rooms: Array<App.Occupants>,
) {
  const dispatch = useAppDispatch()
  const availableMonth = useMemo(
    () => monthIndex ? moment(monthIndexToMonth(monthIndex), 'M-YYYY').format('YYYY-MM') : undefined,
    [monthIndex],
  )
  const requestKey = getCalendarRecommendationsRequestKey(offerId, checkIn, availableMonth, duration, rooms)
  const offerIds = useAppSelector(state => state.recommendations.calendarRecommendations.offerIds)
  const loadingState = useAppSelector(state => state.recommendations.calendarRecommendations.state)
  const storedRequestKey = useAppSelector(state => state.recommendations.calendarRecommendations.requestKey)
  const matchesCurrentRequest = storedRequestKey === requestKey
  const fetching = !matchesCurrentRequest || loadingState === 'loading'
  const resolvedOfferIds: Array<string> = fetching || !offerIds ? EmptyArray : offerIds

  useEffect(() => {
    if ((!checkIn && !monthIndex) || !rooms || !duration) {
      return
    }

    dispatch(fetchCalendarRecommendations(offerId, {
      rooms,
      checkIn,
      availableMonth,
      duration,
    }))
  }, [availableMonth, checkIn, dispatch, duration, monthIndex, offerId, rooms])

  return {
    offerIds: resolvedOfferIds,
    fetching,
  }
}

export default useCalendarRecommendations
